import Backbone from 'backbone'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import TreeActions from 'scoreboard/components/tree-actions'
import DatasetTreeGardener from 'scoreboard/datasets/dataset-tree-gardener'

/**
 * Content View for a tooltip to choose a dataset tree item selector.
 */
const DatasetTreeItemSelectorTooltip = Backbone.View.extend({
	className: 'single-tree-selector',

	/**
	 * @constructs a new DatasetTreeItemSelectorTooltip
	 *
	 * @param {Object} options
	 *
	 * @param {Number} options.datasetTreeId the ID of the dataset tree to render
	 *
	 * @param {Number} [options.initialSelection] the ID of the tree item that
	 * should initially be selected
	 */
	initialize: function (options = {}) {
		this.options = options
	},

	render: function () {
		this.objectGardener = new DatasetTreeGardener({
			finderOptions: {
				type: 'light',
				autofocus: true
			},
			id: this.options.datasetTreeId,
			initialSelection: this.options.initialSelection,
			showClearButton: true
		})
		this.$el.html(this.objectGardener.el)
		this.objectGardener.render()
		this.$('.tree-container').addClass('tree-container-light')

		this.addTreeActions()

		return this
	},

	addTreeActions: function() {
		this.treeActions = new TreeActions({
			el: this.objectGardener.el,
			tree: this.objectGardener.tree,
			buttonContent: i18n.get('common.select')
		}).render()

		this.listenTo(this.treeActions, 'selected', selectedId => {
			let selected = this.objectGardener.tree.get(selectedId)
			this.trigger('select', selected)
		})

		this.listenTo(this.objectGardener, 'clear', selected => {
			this.treeActions.clear()
			this.trigger('clear')
		})
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.objectGardener, this.treeActions], 'remove')
	}
})

export default DatasetTreeItemSelectorTooltip

DatasetTreeItemSelectorTooltip.__filename__ = 'datasets/dataset-tree-item-selector-tooltip.js'
